import React, { useEffect, useState } from "react";
import styled from "styled-components";

const stats = [
    { label: "7+ Aktive år", value: 7, description: "Vi har levert kvalitetsprodukter i over 7 år." },
    { label: "98000+ Fornøyde Kunder", value: 98000, description: "Våre kunder elsker våre produkter og tjenester." },
    { label: "Frakt ved bestilling over 249kr", value: 249, description: "Gratis frakt ved kjøp over 249 kr." },
    { label: "4,9/5 Stjerners Vurdering", value: 4.9, description: "Basert på tusenvis av anmeldelser fra fornøyde kunder." }
];

const HighlightsSection = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [counts, setCounts] = useState(stats.map(() => 0));

    useEffect(() => {
        const handleScroll = () => {
            const section = document.getElementById("highlights");
            if (section) {
                const rect = section.getBoundingClientRect();
                if (rect.top < window.innerHeight * 0.75) {
                    setIsVisible(true);
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        if (isVisible) {
            const increments = stats.map(stat => Math.ceil(stat.value / 100));
            const intervals = stats.map((stat, index) => {
                return setInterval(() => {
                    setCounts(prevCounts => {
                        const newCounts = [...prevCounts];
                        if (newCounts[index] < stat.value) {
                            newCounts[index] += increments[index];
                        } else {
                            newCounts[index] = stat.value;
                            clearInterval(intervals[index]);
                        }
                        return newCounts;
                    });
                }, 20);
            });

            return () => intervals.forEach(interval => clearInterval(interval));
        }
    }, [isVisible]);
    
    return (
        <Section id="highlights">
            <Container>
                {stats.map((stat, index) => (
                    <Box key={index} $isVisible={isVisible}>
                        <h2>
                            {counts[index]}
                            {stat.label.includes("+") ? "+" : ""}
                            {stat.label.includes("/") ? "/5" : ""}
                        </h2>
                        <h5>

                            {stat.label.replace(/[0-9.,+,/]+/, "")}
                        </h5>
                        <p>{stat.description}</p>
                    </Box>
                ))}
            </Container>
        </Section>
    )
}

export default HighlightsSection

const Section = styled.section`
    margin: 4rem 0;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0rem 0;
    justify-content: center;
    background: #2d6a4f;
`;

const Container = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 2rem;
    max-width: 1200px;
    width: 100%;

    @media (min-width: 1680px){
        max-width: 1600px;
    }

    @media (max-width: 1024px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 600px) {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }
`;

const Box = styled.div`
    background: none;
    text-align: center;
    transform: translateY(${({ $isVisible }) => ($isVisible ? "0" : "-50px")});
    opacity: ${({ $isVisible }) => ($isVisible ? "1" : "0")};
    transition: all 0.6s ease-in-out;
    padding: 2rem;
    display: flex;
    align-items:center;
    justify-content:center;
    flex-direction: column;
    gap: 8px;

    h2 {
        font-size: 2rem;
        font-weight: bold;
        color: #fff;
    }

    h5 {
        font-size: 1.4rem;
        color: #fff;
    }

    p {
        font-size: 1rem;
    }

    @media (max-width: 600px){
        
    }
`;